module.exports = __webpack_public_path__ + "e8447b419ebd184448289216fbb3c7a5.glb";